import React from "react";
import {Box,Grid,MenuItem,TextField,CircularProgress, FormControlLabel, Checkbox} from "@mui/material";
import { usePaymentMethods } from "services/hooks/rentals";


const EditTenantPaymentForm = ({
  handleInputChange,
  errors,
  paymentData,
}) => {
  const { paymentMethods, isLoadingPaymentMethods } = usePaymentMethods();
  
  const getPaymentMethodValue = () => {
    if (!paymentData.payment_method) return '';
    if (typeof paymentData.payment_method === 'object' && paymentData.payment_method !== null) {
      return paymentData.payment_method.id || '';
    }
    return paymentData.payment_method;
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            label="Amount Paid"
            type="number"
            name="amount"
            value={paymentData.amount}
            onChange={handleInputChange}
            variant="outlined"
            fullWidth
            error={Boolean(errors.amount)}
            helperText={errors.amount}
          />
        </Grid>

        <Grid item xs={6}>
          {isLoadingPaymentMethods ? (
            <CircularProgress size={24} sx={{ ml: 2 }} />
          ) : (
            <TextField
              label="Payment Method"
              name="payment_method"
              select
              fullWidth
              error={Boolean(errors.payment_method)}
              helperText={errors.payment_method}
              value={getPaymentMethodValue()}
              onChange={handleInputChange}
            >
              {paymentMethods.map((method) => (
                <MenuItem key={method.id} value={method.id}>
                  {method.name}
                </MenuItem>
              ))}
            </TextField>
          )}
        </Grid>

        <Grid item xs={6}>
          <TextField
            label="Date Paid"
            type="date"
            name="date_paid"
            value={paymentData.date_paid}
            onChange={handleInputChange}
            variant="outlined"
            fullWidth
            InputLabelProps={{ shrink: true }}
            error={Boolean(errors.date_paid)}
            helperText={errors.date_paid || "When the payment was received — allocation month is assigned automatically."}
          />
        </Grid>

        <Grid item xs={6}>
          <FormControlLabel
            label="Is this an initial Payment?"
            control={
              <Checkbox
                checked={paymentData.is_initial_payment}
                onChange={handleInputChange}
              />
            }
          />
        </Grid>

        {paymentData.is_initial_payment && (
          <Grid item xs={12}>
            <FormControlLabel
              label="Does this initial payment have a security deposit?"
              control={
                <Checkbox
                  checked={paymentData.has_security_deposit}
                  onChange={handleInputChange}
                />
              }
            />
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default EditTenantPaymentForm;
